export const CONTACT = {
  email: "kontakt@icidentity.se",
  emailHref: "mailto:kontakt@icidentity.se",
  phone: "0702-628066",
  phoneHref: "tel:+46702628066",
};

export const NAV = [
  { id: "tjanster", label: "Tjänster" },
  { id: "om", label: "Om IC Identity" },
  { id: "kontakt", label: "Kontakt" },
];

export const TRUST = [
  { title: "Offentlig sektor", text: "Djup förståelse för kommuner och offentlig verksamhet." },
  { title: "Produktoberoende", text: "Rekommendationer utan bindning till en enskild leverantör." },
  { title: "Decennier av IAM-erfarenhet", text: "Erfarenhet från identitet, säkerhet och digitalisering." },
  { title: "Från strategi till förvaltning", text: "Stöd genom hela IAM-resan – från idé till drift." },
];

export const SERVICES = [
  {
    number: "01",
    title: "Rådgivning och analys",
    lead: "Erfarenhet gör det lättare att fatta rätt beslut.",
    body: [
      "Vi hjälper er att förstå nuläget, identifiera behoven och prioritera rätt väg framåt inom identitet och åtkomst. Med verksamheten som utgångspunkt skapar vi en tydlig strategi för en säker, effektiv och hållbar identitetshantering.",
    ],
  },
  {
    number: "02",
    title: "Implementation och utveckling",
    lead: "Från strategi till fungerande lösning.",
    body: [
      "Ett lyckat IAM-införande handlar om mer än teknik. Det kräver förståelse för verksamheten, tydliga processer och förmågan att få system, människor och identiteter att fungera tillsammans.",
      "IC Identity tar ansvar genom hela resan, från design och konfiguration till integration, test och produktionssättning. Vi arbetar nära verksamheten och bygger lösningar som är enkla att förvalta, utveckla och leva med över tid.",
    ],
  },
  {
    number: "03",
    title: "Support och förvaltning",
    lead: "En IAM-lösning blir aldrig riktigt färdig.",
    body: [
      "Vi hjälper er med support, förvaltning och löpande utveckling så att lösningen fortsätter fungera, utvecklas och skapa värde i takt med verksamhetens behov.",
    ],
  },
];

export const MARQUEE = [
  "Rådgivning",
  "Analys",
  "Strategi",
  "Implementation",
  "Integration",
  "Test",
  "Produktionssättning",
  "Support",
  "Förvaltning",
];
